import React from 'react';
import { MultiValueGenericProps } from 'react-select/src/components/MultiValue';
import classNames from 'classnames';

import { InputClassProps } from '../../input-class-name.util';
import { Option } from '../option.model';

export const MultiValueLabel = ({
  height,
  children,
  innerProps,
}: MultiValueGenericProps<Option> & InputClassProps) => (
  <div
    {...innerProps}
    className={classNames('text-xs text-primary-500', {
      'px-1 py-0.5': height === 'sm',
      'px-2 py-1': height === 'md',
    })}
  >
    {children}
  </div>
);
